/**
 * ProfileInfo Component
 * 
 * Displays profile information fields such as:
 * - Qualifications/credentials
 * - Bio/description
 * - Other profile-related information
 */

import React from 'react';
import { FormFieldGroup } from './FormFieldGroup';
import './ProfileInfo.css';

const ProfileInfo = ({
  qualifications = '',
  bio = '',
  onQualificationsChange,
  onBioChange,
  errors = {},
  touched = {},
  onBlur,
  disabled = false
}) => {
  return (
    <div className="profile-info-container">
      <FormFieldGroup
        label="Qualifications"
        name="qualifications"
        error={touched.qualifications ? errors.qualifications : ''}
        hint="Certifications, licenses, and experience"
      >
        <textarea
          id="qualifications"
          name="qualifications"
          value={qualifications}
          onChange={(e) => onQualificationsChange(e.target.value)}
          onBlur={(e) => onBlur?.(e)}
          placeholder="e.g., USSF Coaching License (A), First Aid CPR Certified, 10+ years coaching experience"
          rows={4}
          disabled={disabled}
          style={{
            width: '100%',
            padding: '10px',
            border: '1px solid var(--color-border)',
            borderRadius: '4px',
            fontFamily: 'inherit',
            resize: 'vertical',
            minHeight: '100px'
          }}
        />
      </FormFieldGroup>

      <FormFieldGroup
        label="Bio"
        name="bio"
        error={touched.bio ? errors.bio : ''}
        hint="Brief professional summary (displayed on the team page)"
      >
        <textarea
          id="bio"
          name="bio"
          value={bio}
          onChange={(e) => onBioChange(e.target.value)}
          onBlur={(e) => onBlur?.(e)}
          placeholder="e.g., Passionate coach with a focus on player development and team building. Specializes in attacking play and technical skill development."
          rows={4}
          disabled={disabled}
          style={{
            width: '100%',
            padding: '10px',
            border: '1px solid var(--color-border)',
            borderRadius: '4px',
            fontFamily: 'inherit',
            resize: 'vertical',
            minHeight: '100px'
          }}
        />
      </FormFieldGroup>
    </div>
  );
};

export default ProfileInfo;
